import React, { useCallback } from 'react'

import { TableHeader, TableRow, SearchFrame, SearchForm, SearchTable, FormContent } from '@front/squirtle'
import { I18n } from '@front/volcanion'

import { Box, Grid } from '@mui/material'

import Callbacks from './callbacks'

import Form from './Form'
import Header from './Header'
import Row from './Row'

const GroupList = props => {
  const filterToForm = useCallback(Callbacks.filterToFormHandler(), [])
  const formToFilter = useCallback(Callbacks.formToFilterHandler(), [])
  return (
    <>
      <Box sx={{ p: 2 }}>
        <Grid container justifyContent='center' alignItems='center'>
          <Grid size={11}>
            <SearchFrame
              model_name='group'
              populate={[]}
              createButtonProps={{ label: I18n.t('group.add') }}
            >
              <SearchForm
                submitOnMount
                filterToForm={filterToForm}
                formToFilter={formToFilter}
              >
                <FormContent><Form /></FormContent>
              </SearchForm>
              <SearchTable>
                <TableHeader><Header /></TableHeader>
                <TableRow><Row /></TableRow>
              </SearchTable>
            </SearchFrame>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default React.memo(GroupList)
